import { TLiftedFormModel } from '../../model/form.model';
import { FORM_MODIFIER } from '../../model/form.modifier';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN } from '@monorepo/types';
import * as _ from 'lodash';

function getLocationTypes(bulkLocationDropdownInfo: TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN) {
  return _.map(_.uniq(_.map(bulkLocationDropdownInfo, (info) => info.location.locationType.toString())), (v) => ({
    value: v,
  }));
}

function getFloors(bulkLocationDropdownInfo: TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN) {
  return _.map(
    _.uniq(
      _.compact(
        _.map(bulkLocationDropdownInfo, (info) => {
          switch (info.location.locationType) {
            case 'FLOATING':
              return info.location.floor.toString();
            default:
              return undefined;
          }
        }),
      ),
    ),
    (v) => ({ value: v }),
  );
}

function getLocationNames(
  bulkLocationDropdownInfo: TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN,
  locationType: string,
) {
  const locationsByLocationType = _.filter(
    bulkLocationDropdownInfo,
    (info) => info.location.locationType === locationType,
  );
  return _.map(
    _.uniq(
      _.compact(
        _.map(locationsByLocationType, (info) => {
          switch (info.location.locationType) {
            case 'EXTERNAL':
            case 'SIBLING':
              return info.location.locationName;
            default:
              return undefined;
          }
        }),
      ),
    ),
    (v) => ({ value: v }),
  );
}
export const BULK_ASSIGN_LOCATION_FORM_MODEL = {
  createModel: (bulkLocationDropdownInfo: TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'DROPDOWN',
            value: '',
            options: getLocationTypes(bulkLocationDropdownInfo),
          },
          metadata: {
            keyName: 'locationType',
            label: 'assign_location.LocationType',
            isRequired: true,
          },
        },
        {
          input: {
            type: 'DROPDOWN',
            value: '',
            options: getLocationNames(bulkLocationDropdownInfo, 'SIBLING'),
          },
          metadata: {
            keyName: 'vendorOrFactoryName',
            label: 'assign_location.Vendor/FactoryName',
            isDisabled: true,
            isRequired: true,
            dependsOn: {
              keyName: 'locationType',
              valuesCallback: (locationType) => {
                switch (locationType) {
                  case 'FLOATING': {
                    return {
                      pseudoKey: 'floor',
                      updatedLabel: 'assign_location.Floor',
                      updatedValues: {
                        type: 'DROPDOWN',
                        options: getFloors(bulkLocationDropdownInfo),
                      },
                    };
                  }
                  case 'SIBLING':
                  case 'EXTERNAL': {
                    return {
                      pseudoKey: 'locationName',
                      updatedLabel: 'assign_location.Vendor/FactoryName',
                      updatedValues: {
                        type: 'DROPDOWN',
                        options: getLocationNames(bulkLocationDropdownInfo, locationType),
                      },
                    };
                  }
                  default:
                    return {
                      updatedLabel: 'assign_location.Floor',
                      updatedValues: {
                        type: 'DROPDOWN',
                        options: getFloors(bulkLocationDropdownInfo),
                      },
                    };
                }
              },
            },
          },
        },
      ],
      isValid: false,
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
